import React from "react";

import Header from "components/header";
import Footer from "components/footer";
import WalletConnectProvider from "context/wallet-connection-context";

const Layout = ({ children }) => {
  return (
    <>
      <WalletConnectProvider>
        <Header />
      </WalletConnectProvider>
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
